<template>
  <v-navigation-drawer
    v-model="panelInner"
    width="360"
    class="pb-6"
    fixed
    right
  >
    <v-list-item
      @click="panelInner = false"
      class="text-button py-1"
    >
      <v-icon class="mr-3 ml-1 primary--text">mdi-chevron-left</v-icon>
      <span class="primary--text">{{ $t('label.manageLabels') }}</span>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item
      class="subtitle-2 mt-2"
      @click="openEditDialog(null)"
    >
      <v-icon class="mr-3 ml-1 text--primary">mdi-plus</v-icon>
      {{ $t('label.createLabel') }}
    </v-list-item>

    <v-data-table
      :headers="tableHeaders"
      :items="contactLabels"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      class="p-no-borders"
      hide-default-footer
      hide-default-header
      @page-count="pageCount = $event"
    >
      <template v-slot:[`item.name`]="{ item }">
        <v-icon class="mr-2 ml-2">mdi-label-outline</v-icon>
        {{ item.name }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="p-table-row-actions">
          <p-btn-icon type="edit" @click="openEditDialog(item)"></p-btn-icon>
          <p-btn-icon type="delete" @click="deleteLabel(item)"></p-btn-icon>
        </div>
      </template>
    </v-data-table>

    <v-pagination
      v-if="pageCount > 1"
      v-model="page"
      :length="pageCount"
      :total-visible="4"
      class="pt-5"
    ></v-pagination>

    <contact-label-edit-dialog
      :dialog.sync="editDialog"
      :label="editLabel"
    ></contact-label-edit-dialog>
  </v-navigation-drawer>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import ContactLabelEditDialog from './ContactLabelEditDialog'
import PBtnIcon from '@/components/PBtnIcon'
import snackbarMixin from '@/mixins/snackbar.mixin'

export default {
  components: {
    ContactLabelEditDialog,
    PBtnIcon
  },


  mixins: [
    snackbarMixin
  ],


  props: {
    panel: Boolean
  },


  data () {
    return {
      editDialog: false,
      editLabel: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 15
    }
  },


  computed: {
    ...mapGetters('contactLabel', ['contactLabels']),

    panelInner: {
      get () {
        return this.panel
      },
      set (val) {
        if (!val) {
          this.editDialog = false
        }
        this.$emit('update:panel', val)
      }
    },

    tableHeaders () {
      return [
        { text: this.$t('label.name'), value: 'name' },
        { text: '', value: 'actions', align: 'end', sortable: false, filterable: false }
      ]
    }
  },


  methods: {
    ...mapActions('contactLabel', ['deleteContactLabel']),

    openEditDialog (label) {
      this.editLabel = label
      this.editDialog = true
    },

    async deleteLabel (label) {
      try {
        const confirm = await this.$confirm(this.$t('label.deleteLabelConfirm', label), { trueText: this.$t('delete') })
        if (confirm === true) {
          this.showSnackbarProcessing()
          this.deleteContactLabel(label.id)
          this.showSnackbarSuccess(this.$t('label.labelDeleted'))
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
